import { useUserStore } from '~/stores/user';

export default defineNuxtRouteMiddleware(async (to) => {
  const userStore = useUserStore();

  // Is User part of this Rollout?
  if (
    userStore.user &&
    to.path.includes('/rollout-project/') &&
    !userStore.user?.rollouts.some(
      (rollout) => rollout.identifier === to.params?.rolloutIdentifier
    )
  ) {
    return navigateTo('/home');
  }
});
